import { useGetChangeApplicationQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import {
  changeApplicationMeta,
  ChangeApplicationSaved,
} from "../../lib/object/entity/change-application";

export function useAppGetChangeApplicationQuery(
  arg: Parameters<typeof useGetChangeApplicationQuery>[0],
  options?: Parameters<typeof useGetChangeApplicationQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: ChangeApplicationSaved | null;
  currentData: ChangeApplicationSaved | null;
  isLoading: ReturnType<typeof useGetChangeApplicationQuery>["isLoading"];
  refetch: ReturnType<typeof useGetChangeApplicationQuery>["refetch"];
  error: ReturnType<typeof useGetChangeApplicationQuery>["error"];
} {
  const {
    data: rawData,
    currentData: rawCurrentData,
    isLoading,
    refetch,
    error,
  } = useGetChangeApplicationQuery(arg, options);

  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return changeApplicationMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  const currentData = useMemo(() => {
    if (isNullish(rawCurrentData)) return null;
    return changeApplicationMeta.toSavedDomainObjectOrNull(
      rawCurrentData,
      skipOptionalValidations,
    );
  }, [rawCurrentData, skipOptionalValidations]);

  return { data, currentData, isLoading, refetch, error };
}
